export default "__VITE_ASSET__DJzdEaIS__"